/*
 * Copyright (c) 2025. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import vehicleMakes from "@/src/services/vehicleMakes";
import { maxStringLength } from "@/src/services/validationRules";

export const trafficAccidentFormDefinitions = {
  vehicleMake: () => vehicleMakes,
  accidentLocalityDescription: () => ({
    validators: [
      {
        validator: maxStringLength,
        params: [255],
        message: "Ihre Eingabe ist zu lang",
      },
    ],
  }),
};
